/** @format */

import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { FormikProps } from "formik";
import * as React from "react";
import { useAppSelector } from "../../app/hooks";
import { selectConstants } from "./Api/constantSlice";
import { ErrorBox } from "../custom/ErrorBox";

interface Props {
  formik: FormikProps<any>;
  isDisabled: boolean;
}
export default function EmploymentStatus({ formik, isDisabled }: Props) {
  const selData = useAppSelector(selectConstants);
  const [helperMessage, setHelperMessage] = React.useState<string>("");
  const mapEnums = (key: string) => {
    switch (key) {
      case "Employed":
        return 0;
      case "SelfEmployed":
        return 1;
      case "Unemployed":
        return 2;
      case "Pensioner":
        return 3;
      default:
        return -1;
    }
  };

  return (
    <>
      {selData.constantState.employmentStatus && (
        <>
          <FormControl fullWidth>
            <InputLabel
              error={
                formik.touched.employmentStatus &&
                Boolean(formik.errors.employmentStatus)
              }
              id="demo-select-small"
            >
              Employment Status
            </InputLabel>
            <Select
              name="employmentStatus"
              labelId="demo-select-small"
              id="demo-select-small"
              value={formik.values.employmentStatus}
              label="Employment Status"
              disabled={isDisabled}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                const status = e.target.value;
                formik.setFieldValue("employmentStatus", status);
                formik.setFieldValue("businessType", -1);
                formik.setFieldValue("cipcRegistrationNumber", "");
                formik.setFieldValue("businessName", "");

                setHelperMessage("");

                if (status === 0) {
                  formik.setFieldValue("employed", true);
                  setHelperMessage(
                    "Please note on the supporting documents tab you will be required to upload a payslip and 3 months bank statement."
                  );
                } else {
                  formik.setFieldValue("employed", false);
                }

                if (status === 1) {
                  setHelperMessage("");
                }

                if (status === 2) {
                  setHelperMessage(
                    "Please note you will have to upload proof of a SASSA Grant Letter or an Unemployment Letter from the Dept of Labour on the next page, and 3 months bank statement"
                  );
                }
              }}
              error={
                formik.touched.employmentStatus &&
                Boolean(formik.errors.employmentStatus)
              }
            >
              <MenuItem value={-1} disabled>
                Select Employment Status
              </MenuItem>
              {selData.constantState.employmentStatus.map(
                (item: string, key: number) => {
                  return (
                    <MenuItem key={key} value={mapEnums(item)}>
                      {item.replace(/([A-Z])/g, " $1").trim()}
                    </MenuItem>
                  );
                }
              )}
            </Select>
          </FormControl>

          <ErrorBox>
          {formik.touched.employmentStatus &&
              (formik.errors.employmentStatus as React.ReactNode)}
                                        </ErrorBox>
          <Box className="helperMessage">{helperMessage}</Box>

        </>
      )}
    </>
  );
}
